<script setup lang="ts">
interface Props {
  loading: boolean
}

defineOptions({ inheritAttrs: false })
defineProps<Props>()
</script>

<template>
  <div v-show="loading" class="w-full h-1 overflow-hidden" v-bind="$attrs">
    <div
      class="h-full w-2/4 bg-linear-to-r from-primary/30 via-primary to-primary/30 animate-indeterminate transform-gpu"
    ></div>
  </div>
</template>
